import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Box,
  Button,
  Text,
} from '@razorpay/blade/components';

interface DiscardModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onDiscard: () => void;
}

export const DiscardModal = ({ isOpen, onCancel, onDiscard }: DiscardModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onDismiss={onCancel}
      size="small"
      accessibilityLabel="Warning: Unsaved Data">
      <ModalHeader title="Warning: Unsaved Data" />

      <ModalBody>
        <Text size="medium" color="surface.text.gray.normal">
          If you leave now, your data will be lost. Do you want to discard, or stay and finish your
          updates?
        </Text>
      </ModalBody>

      <ModalFooter>
        <Box display="flex" gap="spacing.3" justifyContent="flex-end" width="100%">
          <Button variant="tertiary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="secondary" color="negative" onClick={onDiscard}>
            Discard
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
